"use strict";

require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RowSelectCheckbox = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
const _excluded = ["indeterminate", "rowId", "onClickHandler"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const RowSelectCheckbox = exports.RowSelectCheckbox = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
      indeterminate,
      rowId,
      onClickHandler
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const defaultRef = _react.default.useRef();
  const resolvedRef = ref || defaultRef;
  const checkboxId = "".concat(rowId);
  _react.default.useEffect(() => {
    resolvedRef.current.indeterminate = indeterminate;
  }, [resolvedRef, indeterminate]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "formField checkboxField rowSelectCheckbox"
  }, /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: checkboxId
  }, /*#__PURE__*/_react.default.createElement("input", _extends({
    ref: resolvedRef,
    type: "checkbox",
    id: checkboxId,
    name: checkboxId
  }, rest)), /*#__PURE__*/_react.default.createElement("span", {
    className: "sr-only"
  }, "Select/deselect row")));
});
RowSelectCheckbox.propTypes = {
  indeterminate: _propTypes.default.bool,
  rowId: _propTypes.default.string.isRequired,
  onClickHandler: _propTypes.default.func.isRequired
};
RowSelectCheckbox.defaultProps = {
  indeterminate: false
};